/* SCROLL REVEAL */
(()=>{
  const o=new IntersectionObserver(e=>e.forEach(en=>{if(en.isIntersecting)en.target.classList.add('on')}),{threshold:.1});
  document.querySelectorAll('.rv').forEach(el=>o.observe(el));
})();

/* MOBILE NAV */
function toggleMob(){document.getElementById('mnav').classList.toggle('on')}
function navTo(id){
  document.getElementById('mnav').classList.remove('on');
  var el=document.getElementById(id);
  if(!el){window.location.href='/#'+id;return;}
  setTimeout(function(){
    var hh=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hh'))||62;
    var top=el.getBoundingClientRect().top+window.scrollY-hh;
    window.scrollTo({top:top,behavior:'smooth'});
  },60);
}
function toggleLearnMenu(btn){const wrap=btn.closest('.nav-learn');const isOpen=wrap.classList.contains('open');document.querySelectorAll('.nav-learn.open').forEach(el=>el.classList.remove('open'));if(!isOpen)wrap.classList.add('open');}
document.addEventListener('click',function(e){if(!e.target.closest('.nav-learn'))document.querySelectorAll('.nav-learn.open').forEach(el=>el.classList.remove('open'));});
window.addEventListener('scroll',()=>document.getElementById('mnav').classList.remove('on'),{passive:true});

/* FAQ */

function faqTab(btn,catId){
  document.querySelectorAll('.faq-tab').forEach(t=>t.classList.remove('active'));
  document.querySelectorAll('.faq-cat').forEach(t=>t.classList.remove('active'));
  btn.classList.add('active');
  document.getElementById(catId).classList.add('active');
}

function toggleFaq(btn){
  const item=btn.closest('.faq-item');
  const was=item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(i=>i.classList.remove('open'));
  if(!was)item.classList.add('open');
}

/* FLAVOR FILTER */
function filterF(line,btn){
  document.querySelectorAll('.ffbtn').forEach(b=>b.classList.remove('on'));
  btn.classList.add('on');
  document.querySelectorAll('.fcard').forEach(c=>{
    c.style.display=(line==='all'||c.dataset.line===line)?'':'none';
  });
  // re-apply any active search after filter change
  const q=document.getElementById('flavorSearch');
  if(q&&q.value.trim()) searchFlavors(q.value);
}

/* FLAVOR SEARCH */
function searchFlavors(val){
  const q=val.trim().toLowerCase();
  const clearBtn=document.getElementById('fsearchClear');
  if(clearBtn) clearBtn.classList.toggle('vis',q.length>0);
  let visible=0;
  document.querySelectorAll('.fcard').forEach(c=>{
    const name=(c.querySelector('.fc-name')||c.querySelector('.fmc-name')||{}).textContent||'';
    const tags=(c.dataset.tags||'').toLowerCase();
    const match=!q||name.toLowerCase().includes(q)||tags.includes(q);
    if(match){c.style.display='';visible++;}
    else{c.style.display='none';}
  });
  const noRes=document.getElementById('fNoResults');
  if(noRes) noRes.style.display=visible===0?'block':'none';
}

function clearSearch(){
  const inp=document.getElementById('flavorSearch');
  if(inp){inp.value='';searchFlavors('');}
}

/* CART */
let items=JSON.parse(localStorage.getItem('sbj2')||'[]');

function saveItems(){localStorage.setItem('sbj2',JSON.stringify(items))}

/* ─── BUNDLE TIERS ─── */
const BUNDLE_TIERS=[{qty:3,pct:3},{qty:6,pct:6},{qty:12,pct:12}];
function getBundlePct(totalQty){
  let pct=0;
  BUNDLE_TIERS.forEach(t=>{if(totalQty>=t.qty)pct=t.pct;});
  return pct;
}

/* ─── ALL PRODUCTS FOR UPSELL ─── */
const allProducts=[
  {name:'Classic Original',emoji:'🥩',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105'},
  {name:'Black Pepper & Sea Salt',emoji:'🧂',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105'},
  {name:'Bourbon Whiskey',emoji:'🥃',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105'},
  {name:'Garlic & Brown Sugar',emoji:'🍯',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105'},
  {name:'Korean BBQ',emoji:'🔥',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105'},
  {name:'Teriyaki',emoji:'🍯',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105'},
  {name:'Sweet & Spicy',emoji:'🌶️',price:10.99,line:'classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105'},
  {name:'Filet Mignon Original',emoji:'✨',price:13.99,line:'filet',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105'},
  {name:'Filet Mignon Teriyaki',emoji:'✨',price:13.99,line:'filet',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105'}
];

function renderCart(){
  const n=items.reduce((s,i)=>s+i.qty,0);
  const el=document.getElementById('cnum');
  el.textContent=n;el.classList.toggle('on',n>0);
  const bd=document.getElementById('cartBd');
  const ft=document.getElementById('cartFt');
  const bundleBar=document.getElementById('bundleBar');
  const upsellEl=document.getElementById('cartUpsell');

  if(!items.length){
    bd.innerHTML=`<div class="cempty"><img src='//simplybeefjerky.com/cdn/shop/t/161/assets/cow.jpg?v=178341516343755838451777263105' alt="Simply Beef Jerky" class="cempty-i" style="width:80px;height:80px;object-fit:cover;border-radius:50%;display:block;margin:0 auto 16px"><div class="cempty-h">Cart is Empty!</div><p class="cempty-p">Add some jerky to get started.</p></div>`;
    ft.style.display='none';
    if(bundleBar)bundleBar.style.display='none';
    if(upsellEl)upsellEl.innerHTML='';
    return;
  }
  ft.style.display='block';
  bd.innerHTML=items.map((it,i)=>`
    <div class="citem">
      <div class="ci-th">${(labelImgs[it.name]||it.img)?`<img src="${labelImgs[it.name]||it.img}" style="width:44px;height:44px;object-fit:contain;border-radius:6px;">`:it.emoji}</div>
      <div class="ci-inf">
        <div class="ci-nm">${it.name}</div>
        ${it.isSub?'<div style="font-size:11px;font-weight:800;color:#2E7D32;letter-spacing:.3px;margin-bottom:1px">🔁 Subscribe &amp; Save · 10% off</div>':''}
        <div class="ci-pr">$${(it.price*it.qty).toFixed(2)}</div>
        <div class="ci-ctrl">
          <button class="ci-dec" onclick="chQty(${i},-1)">−</button>
          <span class="ci-qty">${it.qty}</span>
          <button class="ci-inc" onclick="chQty(${i},1)">+</button>
        </div>
      </div>
      <button class="ci-rm" onclick="rmItem(${i})">✕</button>
    </div>`).join('');

  // ── Bundle discount ──
  const totalQty=items.reduce((s,i)=>s+i.qty,0);
  const subtotal=items.reduce((s,i)=>s+i.price*i.qty,0);
  const pct=getBundlePct(totalQty);
  const discounted=subtotal*(1-pct/100);
  document.getElementById('cartTot').textContent='$'+discounted.toFixed(2);

  if(bundleBar){
    bundleBar.style.display='block';
    const nextTier=BUNDLE_TIERS.find(t=>t.qty>totalQty);
    const badge=document.getElementById('bundleBadge');
    const savings=document.getElementById('bundleSavings');
    const fill=document.getElementById('bundleFill');
    const hint=document.getElementById('bundleHint');
    if(pct>0){
      bundleBar.classList.add('active');
      badge.textContent=pct+'% Bundle Discount Applied!';
      savings.textContent='You save $'+(subtotal-discounted).toFixed(2);
      fill.style.width='100%';
      hint.textContent=nextTier?`Add ${nextTier.qty-totalQty} more bag${nextTier.qty-totalQty>1?'s':''} to save ${nextTier.pct}%`:'Maximum bundle discount unlocked!';
    } else {
      bundleBar.classList.remove('active');
      const first=BUNDLE_TIERS[0];
      const need=first.qty-totalQty;
      badge.textContent='Bundle & Save';
      savings.textContent='';
      const pctFill=Math.round((totalQty/first.qty)*100);
      fill.style.width=pctFill+'%';
      hint.textContent=`Add ${need} more bag${need>1?'s':''} to save 3% · 6 bags = 6% · 12 bags = 12%`;
    }
  }

  // ── Dynamic upsell: show products not already in cart ──
  if(upsellEl){
    const inCart=new Set(items.map(i=>i.name));
    const suggestions=allProducts.filter(p=>!inCart.has(p.name)).slice(0,4);
    if(suggestions.length){
      upsellEl.innerHTML=`<div class="cu-title">You might also like</div><div class="cu-items">${suggestions.map(p=>`<div class="cu-item" onclick="addCart('${p.name.replace(/'/g,"\'")}','${p.emoji}',${p.price},'${p.line}')"><img src="${p.img}" style="width:36px;height:36px;object-fit:contain;border-radius:6px;margin-bottom:2px"><div class="cu-item-nm">${p.name}</div><div class="cu-item-pr">$${p.price.toFixed(2)}</div></div>`).join('')}</div>`;
    } else {
      upsellEl.innerHTML='';
    }
  }
}

const labelImgs={
  'Classic Original':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105',
  'Black Pepper & Sea Salt':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105',
  'Bourbon Whiskey':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105',
  'Garlic & Brown Sugar':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105',
  'Korean BBQ':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105',
  'Teriyaki':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105',
  'Sweet & Spicy':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105',
  'Filet Mignon Original':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105',
  'Filet Mignon Teriyaki':'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105'
};

function addCart(name,emoji,price,line,isSub){
  const ex=items.find(i=>i.name===name);
  if(ex){ex.qty++;if(isSub!==undefined)ex.isSub=!!isSub;}
  else{items.push({name,emoji,price,line,qty:1,img:labelImgs[name]||'',isSub:!!isSub});}
  saveItems();renderCart();toast((isSub?'🔁 ':'🛒 ')+name+(isSub?' (Subscribe & Save)':' added!'));openCart();
}
function chQty(i,d){items[i].qty+=d;if(items[i].qty<=0)items.splice(i,1);saveItems();renderCart()}
function rmItem(i){items.splice(i,1);saveItems();renderCart()}
function openCart(){
  const cart=document.getElementById('cart');
  const ov=document.getElementById('ov');
  cart.style.removeProperty('display');
  ov.style.removeProperty('display');
  cart.classList.add('on');
  ov.classList.add('on');
}
function closeCart(){document.getElementById('cart').classList.remove('on');document.getElementById('ov').classList.remove('on')}
const _productHandles={
  'Classic Original':'classic-original-1',
  'Black Pepper & Sea Salt':'black-pepper-sea-salt',
  'Bourbon Whiskey':'bourbon-whiskey',
  'Garlic & Brown Sugar':'garlic-and-brown-sugar',
  'Korean BBQ':'beef-jerky-korean-barbecue',
  'Teriyaki':'teriyaki-1',
  'Sweet & Spicy':'sweet-spicy',
  'Filet Mignon Original':'original-filet-mignon',
  'Filet Mignon Teriyaki':'teriyaki-filet-mignon'
};
async function doCheckout(){
  if(!items.length){toast('Your cart is empty!');return;}
  try{
    const variantFetches=items.map(item=>{
      const handle=_productHandles[item.name];
      if(!handle)return Promise.resolve(null);
      return fetch('/products/'+handle+'.js').then(r=>r.json()).then(p=>({id:p.variants[0].id,quantity:item.qty})).catch(()=>null);
    });
    const resolved=(await Promise.all(variantFetches)).filter(Boolean);
    if(resolved.length){
      await fetch('/cart/clear.js',{method:'POST'});
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:resolved})});
    }
  }catch(e){}
  window.location.href='/checkout';
}

/* ── CHECKOUT PAGE ── */
let _ckShipping=0;

function showCheckout(){
  closeCart();
  document.getElementById('checkout-page').style.display='block';
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#privacy-page):not(#terms-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='none');
  document.getElementById('footer').style.display='none';
  renderCheckoutSummary();
  window.scrollTo({top:0,behavior:'smooth'});
  history.pushState({checkout:true},'',window.location.pathname+'#checkout');
}

function hideCheckout(){
  document.getElementById('checkout-page').style.display='none';
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#privacy-page):not(#terms-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='');
  document.getElementById('footer').style.display='';
  history.pushState({},'',window.location.pathname);
  window.scrollTo({top:0,behavior:'smooth'});
  openCart();
}

function renderCheckoutSummary(){
  const list=document.getElementById('ck-items-list');
  const totalsEl=document.getElementById('ck-totals');
  if(!list||!totalsEl)return;
  const sub=items.reduce((s,i)=>s+i.price*i.qty,0);
  list.innerHTML=items.length?items.map(item=>{
    const _img=labelImgs[item.name]||item.img||'';const imgHtml=_img?`<img class="ck-sum-img" src="${_img}" alt="${item.name}">`:`<div class="ck-sum-img-em">${item.emoji||'🥩'}</div>`;
    return`<div class="ck-sum-item">${imgHtml}<div style="flex:1;min-width:0"><div class="ck-sum-iname">${item.name}${item.isSub?'<span style="color:#2E7D32;font-size:16px;margin-left:6px;font-weight:800">● Subscribe</span>':''}</div><div class="ck-sum-isub">${item.isSub?'Auto-refill · 10% off':'One-time purchase'}</div><div class="ck-sum-iqty">Qty: ${item.qty}</div></div><div class="ck-sum-iprice">$${(item.price*item.qty).toFixed(2)}</div></div>`;
  }).join(''):'<div style="padding:24px;text-align:center;color:var(--gray);font-size:16px;font-weight:700">Your cart is empty</div>';
  const ship=_ckShipping;
  const tax=Math.round(sub*0.07*100)/100;
  const total=sub+ship+tax;
  totalsEl.innerHTML=`<div class="ck-sum-row"><span>Subtotal</span><span>$${sub.toFixed(2)}</span></div><div class="ck-sum-row"><span>Shipping</span><span class="${ship===0?'ck-sum-free':''}">${ship===0?'FREE':'$'+ship.toFixed(2)}</span></div><div class="ck-sum-row"><span>Est. Tax</span><span>$${tax.toFixed(2)}</span></div><div class="ck-sum-row total"><span>Total</span><span>$${total.toFixed(2)}</span></div>`;
}

function selectShipping(el,type){
  document.querySelectorAll('.ck-ship-opt').forEach(o=>{
    o.classList.remove('sel');
    const dot=o.querySelector('.ck-ship-radio-dot');
    if(dot)dot.remove();
  });
  el.classList.add('sel');
  const radio=el.querySelector('.ck-ship-radio');
  if(!radio.querySelector('.ck-ship-radio-dot')){const dot=document.createElement('div');dot.className='ck-ship-radio-dot';radio.appendChild(dot);}
  _ckShipping=type==='express'?9.99:0;
  renderCheckoutSummary();
}

function applyCkPromo(){
  const input=document.getElementById('ck-promo-input');
  const msg=document.getElementById('ck-promo-msg');
  if(!input||!msg)return;
  const code=input.value.trim().toUpperCase();
  if(!code){return;}
  msg.style.display='block';
  if(code==='JERKY10'||code==='WELCOME10'){
    msg.style.color='#16A34A';msg.textContent='✓ Code applied — 10% off!';
  } else {
    msg.style.color='#DC2626';msg.textContent='Invalid code. Please try again.';
  }
}

function toggleCkPromo(){
  const wrap=document.getElementById('ckPromoWrap');
  const arrow=document.getElementById('ckPromoArrow');
  if(!wrap||!arrow)return;
  const open=wrap.style.display!=='none';
  wrap.style.display=open?'none':'block';
  arrow.style.transform=open?'':'rotate(180deg)';
}

function fmtCard(el){
  let v=el.value.replace(/\D/g,'').slice(0,16);
  el.value=v.replace(/(.{4})/g,'$1  ').trim();
}

function fmtExp(el){
  let v=el.value.replace(/\D/g,'');
  if(v.length>2)v=v.slice(0,2)+' / '+v.slice(2,4);
  el.value=v;
}

function placeOrder(){
  const email=document.getElementById('ck-email')?document.getElementById('ck-email').value:'';
  if(!email){toast('Please enter your email address');return;}
  toast('🎉 Order placed! Redirecting...');
  setTimeout(()=>window.location.href='https://simplybeefjerky.com',1800);
}
function submitEmail(e){e.preventDefault();const input=e.target.querySelector('input');toast('🎉 Welcome to the crew! Check your inbox for 10% off.');input.value='';}
function submitAffiliate(e){e.preventDefault();toast('✅ Application received! We\'ll be in touch within 48 hours.');e.target.reset();}

/* ── FLAVOR QUIZ ── */
const quizFlavors={
  classic_og:{name:'Classic Original',sub:'Liquid Smoke Added',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105',color:'#FFADAD',desc:'Clean, classic beef jerky at its best. Hickory smoke, simple seasonings, bold beef flavor. The one that started it all.',price:10.99,cartKey:'Classic Original'},
  bpss:{name:'Black Pepper & Sea Salt',sub:'Bold & Clean',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105',color:'#A0C4FF',desc:'Cracked black pepper and flaky sea salt on whole muscle beef. No frills — just a bold, clean bite that lets the beef shine.',price:10.99,cartKey:'Black Pepper & Sea Salt'},
  bourbon:{name:'Bourbon Whiskey',sub:'Rich & Smoky',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105',color:'#FDFFB6',desc:'Rich bourbon notes, natural hickory smoke, and a subtle sweetness that lingers. For those who appreciate the finer things.',price:10.99,cartKey:'Bourbon Whiskey'},
  garlic_bs:{name:'Garlic & Brown Sugar',sub:'Sweet Meets Savory',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105',color:'#CAFFBF',desc:'Roasted garlic and caramelized brown sugar in perfect harmony. Sweet, savory, and dangerously addictive.',price:10.99,cartKey:'Garlic & Brown Sugar'},
  korean:{name:'Korean BBQ',sub:'Bold & Adventurous',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105',color:'#FFAFCC',desc:'Gochujang heat, sesame, soy, and a touch of sweetness inspired by Korean BBQ. A bold flavor adventure in every bite.',price:10.99,cartKey:'Korean BBQ'},
  teriyaki:{name:'Teriyaki',sub:'Sweet & Savory',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105',color:'#FDFFB6',desc:'Sweet teriyaki glaze on premium beef — a classic combination that\'s perfectly balanced, mild, and endlessly satisfying.',price:10.99,cartKey:'Teriyaki'},
  sweet_spicy:{name:'Sweet & Spicy',sub:'Heat Meets Sweet',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105',color:'#9BF6FF',desc:'Honey sweetness up front, then a slow-building heat that keeps you reaching for more. The ultimate sweet-heat combo.',price:10.99,cartKey:'Sweet & Spicy'},
  fm_og:{name:'Filet Mignon Original',sub:'Premium · Sweet & Smoky',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105',color:'#BDB2FF',desc:'The same cut you order at a steakhouse — made into extraordinary jerky. Brown sugar, hickory smoke, and pure filet tenderness.',price:13.99,cartKey:'Filet Mignon Original'},
  fm_teriyaki:{name:'Filet Mignon Teriyaki',sub:'Premium · Sweet & Savory',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105',color:'#FFD6E0',desc:'Tender filet mignon bathed in a rich teriyaki glaze. Premium quality, premium flavor. You deserve this.',price:13.99,cartKey:'Filet Mignon Teriyaki'}
};

const quizScoring={
  1:{sweet:['garlic_bs','teriyaki','fm_teriyaki','sweet_spicy'],smoky:['bourbon','fm_og','classic_og'],savory:['classic_og','bpss','fm_og'],spicy:['korean','sweet_spicy','bpss']},
  2:{none:['classic_og','bpss','bourbon','garlic_bs','teriyaki','fm_og','fm_teriyaki'],low:['classic_og','bpss','garlic_bs','bourbon','fm_og'],medium:['korean','sweet_spicy','bpss'],high:['korean','sweet_spicy']},
  3:{american:['classic_og','bpss','bourbon','fm_og'],asian:['korean','teriyaki','fm_teriyaki'],sweet:['garlic_bs','teriyaki','sweet_spicy','fm_teriyaki'],premium:['fm_og','fm_teriyaki','bourbon']},
  4:{fuel:['classic_og','bpss','fm_og'],craving:['garlic_bs','teriyaki','sweet_spicy','korean'],treat:['fm_og','fm_teriyaki','bourbon'],adventure:['korean','sweet_spicy','garlic_bs']}
};

let quizAnswers={},quizCurrentStep=1;

function quizAnswer(q,val){
  quizAnswers[q]=val;
  const opts=document.querySelectorAll('#qs'+q+' .quiz-opt');
  opts.forEach(o=>o.classList.remove('selected'));
  event.currentTarget.classList.add('selected');
  setTimeout(()=>{
    if(q<4){quizGoTo(q+1);}else{quizShowResult();}
  },350);
}

function quizGoTo(step){
  document.querySelectorAll('.quiz-step').forEach(s=>s.classList.remove('active'));
  document.getElementById('qs'+step).classList.add('active');
  quizCurrentStep=step;
  document.getElementById('quizProgress').style.width=((step-1)/4*100)+'%';
}

function quizShowResult(){
  const scores={};
  Object.keys(quizFlavors).forEach(k=>scores[k]=0);
  Object.entries(quizAnswers).forEach(([q,val])=>{
    const boosts=quizScoring[q][val]||[];
    boosts.forEach(f=>scores[f]=(scores[f]||0)+1);
  });
  const winner=Object.entries(scores).sort((a,b)=>b[1]-a[1])[0][0];
  const f=quizFlavors[winner];
  document.getElementById('quizResultImg').src=f.img;
  document.getElementById('quizResultImg').alt=f.name;
  document.getElementById('quizResultImgWrap').style.background=f.color;
  document.getElementById('quizResultName').textContent=f.name;
  window._quizFlavorResult=f.name;
  document.getElementById('quizResultSub').textContent=f.sub;
  document.getElementById('quizResultDesc').textContent=f.desc;
  document.getElementById('quizResultBtn').onclick=()=>{addCart(f.cartKey,'🥩',f.price,'classic');toast('🛒 '+f.name+' added to cart!');};
  document.getElementById('quizProgress').style.width='100%';
  document.querySelectorAll('.quiz-step').forEach(s=>s.classList.remove('active'));
  document.getElementById('qs-result').classList.add('active');
}

function quizReset(){
  quizAnswers={};quizCurrentStep=1;
  document.querySelectorAll('.quiz-opt').forEach(o=>o.classList.remove('selected'));
  document.getElementById('quizProgress').style.width='0%';
  document.querySelectorAll('.quiz-step').forEach(s=>s.classList.remove('active'));
  document.getElementById('qs1').classList.add('active');
}

/* TOAST */
let tt;
function toast(msg){
  clearTimeout(tt);
  const t=document.getElementById('toast');
  t.textContent=msg;t.classList.add('on');
  tt=setTimeout(()=>t.classList.remove('on'),3000);
}

renderCart();

/* ── GIFT CARD AMOUNT SELECTOR ── */
function selectAmt(el){document.querySelectorAll('.gc-amt').forEach(b=>b.classList.remove('sel'));el.classList.add('sel')}

/* ── COUNTDOWN TIMER (counts to midnight tonight) ── */
(function startCountdown(){
  function tick(){
    const now=new Date();
    const end=new Date(now);
    end.setHours(23,59,59,999);
    const diff=end-now;
    const h=Math.floor(diff/3600000);
    const m=Math.floor((diff%3600000)/60000);
    const s=Math.floor((diff%60000)/1000);
    const ph=document.getElementById('cdH');
    const pm=document.getElementById('cdM');
    const ps=document.getElementById('cdS');
    if(ph)ph.textContent=String(h).padStart(2,'0');
    if(pm)pm.textContent=String(m).padStart(2,'0');
    if(ps)ps.textContent=String(s).padStart(2,'0');
  }
  tick();
  setInterval(tick,1000);
})();

/* ── TYPEWRITER ── */
(function(){
  const el=document.getElementById('heroType');
  if(!el)return;
  const phrases=['Bold Flavors.','Real Beef.','No Shortcuts.','No Nitrates Added.','Made in USA.','No MSG Added.'];
  let pi=0,ci=0,deleting=false;
  function tick(){
    const phrase=phrases[pi];
    if(!deleting){
      el.textContent=phrase.slice(0,ci+1);
      ci++;
      if(ci===phrase.length){setTimeout(()=>{deleting=true;tick()},1800);return;}
    } else {
      el.textContent=phrase.slice(0,ci-1);
      ci--;
      if(ci===0){deleting=false;pi=(pi+1)%phrases.length;}
    }
    setTimeout(tick,deleting?55:95);
  }
  tick();
})();

/* ── SCROLL: header shadow + back-to-top ── */
(function(){
  const hdr=document.getElementById('hdr');
  const btt=document.getElementById('btt');
  window.addEventListener('scroll',()=>{
    const y=window.scrollY;
    if(hdr)hdr.classList.toggle('scrolled',y>10);
    if(btt)btt.classList.toggle('on',y>400);
  },{passive:true});
})();

/* ── MOTION REEL ── */
(function(){
  const slides=document.querySelectorAll('.reel-slide');
  const dotsEl=document.getElementById('reelDots');
  if(!slides.length)return;
  // build progress bar
  const prog=document.createElement('div');prog.className='reel-progress';
  const fill=document.createElement('div');fill.className='reel-progress-fill';
  prog.appendChild(fill);document.querySelector('.reel-stage').appendChild(prog);
  // build dots
  slides.forEach((_,i)=>{
    const d=document.createElement('div');d.className='reel-dot'+(i===0?' active':'');
    d.onclick=()=>goTo(i);dotsEl.appendChild(d);
  });
  let cur=0,timer;
  function goTo(n){
    slides[cur].classList.remove('active');
    document.querySelectorAll('.reel-dot')[cur].classList.remove('active');
    cur=(n+slides.length)%slides.length;
    slides[cur].classList.add('active');
    document.querySelectorAll('.reel-dot')[cur].classList.add('active');
    fill.classList.remove('running');
    void fill.offsetWidth;
    fill.classList.add('running');
    clearInterval(timer);timer=setInterval(()=>goTo(cur+1),5200);
  }
  fill.classList.add('running');
  timer=setInterval(()=>goTo(cur+1),5200);
  window.reelStep=function(d){goTo(cur+d)};
})();

/* ── RECENTLY PURCHASED POPUP ── */
(function(){
  const orders=[
    {emoji:'🔥',name:'Korean BBQ',loc:'Miami, FL',ago:'2 min ago'},
    {emoji:'🥩',name:'Classic Original',loc:'Fort Lauderdale, FL',ago:'5 min ago'},
    {emoji:'🍯',name:'Teriyaki',loc:'Orlando, FL',ago:'8 min ago'},
    {emoji:'🌶️',name:'Sweet & Spicy',loc:'Tampa, FL',ago:'11 min ago'},
    {emoji:'🥃',name:'Bourbon Whiskey',loc:'Boca Raton, FL',ago:'14 min ago'},
    {emoji:'🎩',name:'Filet Mignon Original',loc:'Jacksonville, FL',ago:'18 min ago'},
    {emoji:'🧂',name:'Black Pepper & Sea Salt',loc:'Sarasota, FL',ago:'22 min ago'},
    {emoji:'🧄',name:'Garlic & Brown Sugar',loc:'Naples, FL',ago:'25 min ago'},
  ];
  let idx=0;
  function showNext(){
    const o=orders[idx%orders.length];
    document.getElementById('rp-emoji').textContent=o.emoji;
    document.getElementById('rp-name').textContent='Someone in '+o.loc+' ordered '+o.name+'!';
    document.getElementById('rp-meta').textContent=o.ago;
    const el=document.getElementById('recent-purchase');
    el.classList.add('on');
    setTimeout(()=>el.classList.remove('on'),5000);
    idx++;
  }
  setTimeout(()=>{showNext();setInterval(showNext,18000);},7000);
})();

/* ── STICKY BUNDLE FLOAT ── */
(function(){
  const bf=document.getElementById('bundle-float');
  const btt=document.getElementById('btt');
  let bundleVisible=false;
  window.addEventListener('scroll',()=>{
    const y=window.scrollY;
    const show=y>600;
    if(show!==bundleVisible){
      bundleVisible=show;
      bf.classList.toggle('on',show);
    }
    // hide bundle float when near footer
    const docH=document.body.scrollHeight;
    if(y+window.innerHeight>docH-400) bf.classList.remove('on');
  },{passive:true});
  // Hide bundle float when user clicks it
  document.querySelector('.bf-btn').addEventListener('click',()=>{
    setTimeout(()=>bf.classList.remove('on'),1000);
  });
})();

/* ── SUBSCRIBE & SAVE TOGGLE ── */
function isSubChecked(btn){
  const card=btn.closest('.fcard,.fmcard');
  const cb=card?card.querySelector('input[type=checkbox]'):null;
  return !!(cb&&cb.checked);
}
function getSubPrice(btn,base){
  return isSubChecked(btn)?Math.round(base*.90*100)/100:base;
}
function toggleSub(cb,base){
  const card=cb.closest('.fcard,.fmcard');
  const prEl=card?card.querySelector('.fc-price,.fmcard-price'):null;
  if(!prEl)return;
  if(cb.checked){
    prEl.textContent='$'+(Math.round(base*.90*100)/100).toFixed(2);
    prEl.style.color='#4CAF50';
  }else{
    prEl.textContent='$'+base.toFixed(2);
    prEl.style.color='';
  }
}

/* ── EMAIL POPUP ── */
(function(){
  if(sessionStorage.getItem('popupShown'))return;
  setTimeout(()=>{
    document.getElementById('emailPopup').classList.add('on');
    sessionStorage.setItem('popupShown','1');
  },9000);
})();
function closePopup(){document.getElementById('emailPopup').classList.remove('on')}
function closePopupOutside(e){if(e.target===document.getElementById('emailPopup'))closePopup()}
function submitPopup(e){
  e.preventDefault();
  const btn=e.target.querySelector('.popup-btn');
  btn.textContent='Sending your code...';btn.disabled=true;
  setTimeout(()=>{
    btn.textContent='Check your inbox! 🎉';btn.style.background='#2a9d2a';
    setTimeout(closePopup,2500);
  },1000);
}

/* ── NUTRITION MODAL ── */
const nutritionData={
  'classic-original':{cal:80,fat:1,satfat:0,chol:30,sodium:280,carb:6,fiber:0,sugar:5,protein:9,
    ingredients:'Beef, Water, Sea Salt, Brown Sugar, Black Pepper, Garlic Powder, Celery Juice Powder*, Liquid Smoke. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'black-pepper':{cal:90,fat:1.5,satfat:.5,chol:35,sodium:310,carb:4,fiber:0,sugar:2,protein:10,
    ingredients:'Beef, Water, Sea Salt, Black Pepper, Garlic Powder, Onion Powder, Celery Juice Powder*. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'bourbon':{cal:70,fat:1,satfat:0,chol:30,sodium:170,carb:5,fiber:0,sugar:4,protein:8,
    ingredients:'Beef, Water, Bourbon Whiskey, Brown Sugar, Sea Salt, Black Pepper, Garlic Powder, Celery Juice Powder*. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'garlic-sugar':{cal:80,fat:1,satfat:0,chol:30,sodium:200,carb:7,fiber:0,sugar:5,protein:9,
    ingredients:'Beef, Water, Brown Sugar, Sea Salt, Garlic Powder, Black Pepper, Onion Powder, Celery Juice Powder*. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'korean-bbq':{cal:70,fat:1,satfat:0,chol:25,sodium:180,carb:5,fiber:0,sugar:3,protein:8,
    ingredients:'Beef, Water, Soy Sauce (Water, Wheat, Soybeans, Salt), Brown Sugar, Gochujang (Red Pepper Paste), Sesame Oil, Garlic Powder, Ginger, Celery Juice Powder*. Contains: Soy, Wheat. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'teriyaki':{cal:80,fat:1,satfat:0,chol:30,sodium:220,carb:7,fiber:0,sugar:6,protein:10,
    ingredients:'Beef, Water, Soy Sauce (Water, Wheat, Soybeans, Salt), Brown Sugar, Pineapple Juice Concentrate, Garlic Powder, Ginger, Celery Juice Powder*. Contains: Soy, Wheat. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'sweet-spicy':{cal:80,fat:1,satfat:0,chol:30,sodium:240,carb:6,fiber:0,sugar:5,protein:10,
    ingredients:'Beef, Water, Honey, Brown Sugar, Cayenne Pepper, Sea Salt, Black Pepper, Garlic Powder, Celery Juice Powder*. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'fm-original':{cal:80,fat:1.5,satfat:.5,chol:35,sodium:290,carb:5,fiber:0,sugar:4,protein:10,
    ingredients:'Beef Tenderloin (Filet Mignon), Water, Brown Sugar, Sea Salt, Hickory Smoke Flavor, Black Pepper, Garlic Powder, Celery Juice Powder*. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'},
  'fm-teriyaki':{cal:80,fat:1.5,satfat:.5,chol:30,sodium:200,carb:6,fiber:0,sugar:5,protein:10,
    ingredients:'Beef Tenderloin (Filet Mignon), Water, Soy Sauce (Water, Wheat, Soybeans, Salt), Brown Sugar, Pineapple Juice Concentrate, Garlic Powder, Ginger, Celery Juice Powder*. Contains: Soy, Wheat. *No nitrates or nitrites added except those naturally occurring in celery juice powder.'}
};
const flavorNames={
  'classic-original':'Classic Original','black-pepper':'Black Pepper & Sea Salt',
  'bourbon':'Bourbon Whiskey','garlic-sugar':'Garlic & Brown Sugar',
  'korean-bbq':'Korean BBQ','teriyaki':'Teriyaki',
  'sweet-spicy':'Sweet & Spicy','fm-original':'Filet Mignon Original','fm-teriyaki':'Filet Mignon Teriyaki'
};
const slugMap={
  'Classic Original':'classic-original','Black Pepper & Sea Salt':'black-pepper',
  'Bourbon Whiskey':'bourbon','Garlic & Brown Sugar':'garlic-sugar',
  'Korean BBQ':'korean-bbq','Teriyaki':'teriyaki',
  'Sweet & Spicy':'sweet-spicy','Filet Mignon Original':'fm-original','Filet Mignon Teriyaki':'fm-teriyaki'
};
function openNutrition(flavor){
  const slug=slugMap[flavor]||'classic-original';
  document.getElementById('nfact-select').value=slug;
  updateNutrition(slug);
  document.getElementById('nutritionModal').classList.add('on');
}
function closeNutrition(){document.getElementById('nutritionModal').classList.remove('on')}
function closeNutritionOutside(e){if(e.target===document.getElementById('nutritionModal'))closeNutrition()}
function updateNutrition(slug){
  const d=nutritionData[slug]||nutritionData['classic-original'];
  const name=flavorNames[slug]||'Nutrition Facts';
  document.getElementById('nmodal-flavor-name').textContent=name+' — Nutrition Facts';
  const pct=(v,dv)=>Math.round(v/dv*100)+'%';
  document.getElementById('nfact-content').innerHTML=`
    <div class="nfact-header">Nutrition Facts</div>
    <div class="nfact-serving">Serving Size 1 oz (28g) · About 2.5 Servings Per Container</div>
    <div class="nfact-calories-row"><span class="nfact-cal-lbl">Calories</span><span class="nfact-cal-n">${d.cal}</span></div>
    <div class="nfact-row nfact-pct-row">% Daily Value*</div>
    <div class="nfact-row thick"><b>Total Fat</b> ${d.fat}g<span>${pct(d.fat,78)}</span></div>
    <div class="nfact-row indent">Saturated Fat ${d.satfat}g<span>${pct(d.satfat,20)}</span></div>
    <div class="nfact-row indent"><i>Trans</i> Fat 0g<span></span></div>
    <div class="nfact-row thick"><b>Cholesterol</b> ${d.chol}mg<span>${pct(d.chol,300)}</span></div>
    <div class="nfact-row thick"><b>Sodium</b> ${d.sodium}mg<span>${pct(d.sodium,2300)}</span></div>
    <div class="nfact-row thick"><b>Total Carbohydrate</b> ${d.carb}g<span>${pct(d.carb,275)}</span></div>
    <div class="nfact-row indent">Dietary Fiber ${d.fiber}g<span>${pct(d.fiber,28)}</span></div>
    <div class="nfact-row indent">Total Sugars ${d.sugar}g<span></span></div>
    <div class="nfact-row thick"><b>Protein</b> ${d.protein}g<span></span></div>
    <div class="nfact-ingred-box">
      <div class="nfact-ingred-label">Ingredients</div>
      <div class="nfact-ingred-text">${d.ingredients}</div>
    </div>
  `;
}

/* ── ORDER TRACKING ── */
function trackOrder(e){
  e.preventDefault();
  const num=document.getElementById('track-num').value.trim();
  const res=document.getElementById('track-result');
  res.style.display='block';
  res.style.background='#FFF9E6';res.style.borderColor='var(--amber)';res.style.color='#795548';
  res.textContent='Looking up order '+num+'...';
  setTimeout(()=>{
    res.style.background='#F0FFF4';res.style.borderColor='#4CAF50';res.style.color='#2E7D32';
    res.innerHTML='<strong>📦 Order '+num+'</strong><br>Status: <strong>In Transit</strong> · Estimated delivery: 2–3 business days.<br><small style="color:#555">For detailed tracking, check the email we sent when your order shipped, or contact us at sales@simplybeefjerky.com</small>';
  },1400);
}

/* ── LOYALTY / REFERRAL ── */
function getLoyaltyLink(){
  const email=document.getElementById('loyalty-email').value.trim();
  if(!email)return;
  const res=document.getElementById('loyalty-result');
  res.style.display='block';
  res.textContent='Generating your link...';
  setTimeout(()=>{
    const code=email.split('@')[0].replace(/[^a-z0-9]/gi,'').toUpperCase().slice(0,8);
    res.innerHTML='<strong>🎉 Your link is ready!</strong><br>Share this with friends: <strong style="color:var(--red)">simplybeefjerky.com?ref='+code+'</strong><br>We\'ll email your full referral dashboard to '+email;
  },1000);
}



/* ── COOKIE CONSENT ── */
(function(){
  if(!localStorage.getItem('sbj-cookie')){
    setTimeout(()=>document.getElementById('cookieBar').classList.add('show'),1500);
  }
})();
function cookieAccept(){
  localStorage.setItem('sbj-cookie','accepted');
  document.getElementById('cookieBar').classList.remove('show');
}
function cookieDecline(){
  localStorage.setItem('sbj-cookie','declined');
  document.getElementById('cookieBar').classList.remove('show');
}

/* ── QUIZ SHARE ── */
function shareQuizResult(platform){
  const flavor=window._quizFlavorResult||document.getElementById('quizResultName').textContent||'Simply Beef Jerky';
  const shareText=`My Simply Beef Jerky flavor match is ${flavor}! 🥩 Take the quiz to find yours: simplybeefjerky.com/#quiz`;
  if(platform==='copy'){
    navigator.clipboard.writeText(shareText).then(()=>toast('✅ Copied! Paste it anywhere to share.')).catch(()=>{});
  } else if(platform==='twitter'){
    /* No separate &url= so no link card — the flavor text is the focus */
    window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent(shareText),'_blank');
  } else if(platform==='facebook'){
    const url='https://simplybeefjerky.com/#quiz';
    window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url),'_blank');
  }
}

function handleContact(e){
  e.preventDefault();
  const btn=e.target.querySelector('.cf-btn');
  btn.textContent='Sending…';
  btn.disabled=true;
  setTimeout(()=>{
    btn.textContent='Message Sent! ✅';
    btn.style.background='#2a9d2a';
    e.target.reset();
    setTimeout(()=>{btn.textContent='Send Message 🚀';btn.style.background='';btn.disabled=false;},4000);
  },1200);
}

/* ── TASTE FILTER ── */
function filterTaste(taste,btn){
  document.querySelectorAll('.ffbtn2').forEach(b=>b.classList.remove('on'));
  btn.classList.add('on');
  document.querySelectorAll('.fcard').forEach(c=>{
    const cardTaste=c.dataset.taste||'';
    const show=taste==='all'||cardTaste===taste;
    // Respect existing line filter
    const lineBtn=document.querySelector('.ffbtn.on');
    const m=lineBtn&&lineBtn.getAttribute('onclick').match(/\'([^\']+)\'/);const activeLine=m?m[1]:'all';
    const lineOk=activeLine==='all'||c.dataset.line===activeLine;
    c.style.display=(show&&lineOk)?'':'none';
  });
  const q=document.getElementById('flavorSearch');
  if(q&&q.value.trim()) searchFlavors(q.value);
}

/* ── DARK MODE ── */
function headerSearchOpen(){
  const ov=document.getElementById('search-overlay');
  ov.classList.add('on');
  document.body.style.overflow='hidden';
  setTimeout(()=>{const inp=document.getElementById('search-overlay-input');if(inp){inp.focus();inp.value='';searchOverlay('');}},50);
}
function closeSearchOverlay(e){
  if(e&&e.target!==document.getElementById('search-overlay'))return;
  document.getElementById('search-overlay').classList.remove('on');
  document.body.style.overflow='';
}
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.getElementById('search-overlay').classList.remove('on'),document.body.style.overflow='';});
function searchOverlay(val){
  const q=val.trim().toLowerCase();
  const res=document.getElementById('search-overlay-results');
  const allProducts=Object.entries(pdProducts);
  const matches=q?allProducts.filter(([s,p])=>p.name.toLowerCase().includes(q)||p.sub.toLowerCase().includes(q)):allProducts;
  if(matches.length===0){res.innerHTML='<div class="sov-empty">No flavors found for "'+val+'"</div>';return;}
  res.innerHTML=matches.map(([s,p])=>`<div class="sov-item" onclick="closeSearchOverlay();showProduct('${s}')">
    <img class="sov-img" src="${p.img}" alt="${p.name}">
    <div class="sov-info"><div class="sov-name">${p.name}</div><div class="sov-sub">${p.sub}</div></div>
    <div class="sov-price">$${p.price.toFixed(2)}</div>
  </div>`).join('');
}
function toggleDark(){
  const isDark=document.body.classList.toggle('dark-mode');
  document.getElementById('darkToggle').textContent=isDark?'☀️':'🌙';
  localStorage.setItem('sbj-dark',isDark?'1':'0');
}
(function(){
  if(localStorage.getItem('sbj-dark')==='1'){
    document.body.classList.add('dark-mode');
    const t=document.getElementById('darkToggle');
    if(t) t.textContent='☀️';
  }
})();

/* ── BACK TO TOP ── */
(function(){
  const btn=document.getElementById('btt');
  if(!btn) return;
  window.addEventListener('scroll',()=>{
    btn.classList.toggle('vis',window.scrollY>300);
  },{passive:true});
})();

/* ── EXIT INTENT ── */
(function(){
  let shown=sessionStorage.getItem('exitShown');
  if(shown) return;
  let timer=setTimeout(()=>{
    document.addEventListener('mouseleave',function handler(e){
      if(e.clientY<=0){
        document.getElementById('exitOverlay').classList.add('show');
        sessionStorage.setItem('exitShown','1');
        document.removeEventListener('mouseleave',handler);
      }
    });
  },5000); // wait 5s before activating
})();
/* ── BUNDLE PICKER ── */
const allFlavors=[
  {name:'Classic Original',emoji:'🥩',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105'},
  {name:'Black Pepper & Sea Salt',emoji:'🧂',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105'},
  {name:'Bourbon Whiskey',emoji:'🥃',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105'},
  {name:'Garlic & Brown Sugar',emoji:'🧄',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105'},
  {name:'Korean BBQ',emoji:'🌶',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105'},
  {name:'Teriyaki',emoji:'🍯',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105'},
  {name:'Sweet & Spicy',emoji:'🌶️',price:10.99,line:'Classic',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105'},
  {name:'Filet Mignon Original',emoji:'✨',price:13.99,line:'Filet Mignon',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105'},
  {name:'Filet Mignon Teriyaki',emoji:'✨',price:13.99,line:'Filet Mignon',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105'}
];
let bpickQty=3,bpickPrice=0,bpickSelected=[];
function openBundlePicker(qty,price){
  bpickQty=qty;bpickPrice=price;bpickSelected=[];
  document.getElementById('bpickTitle').textContent='Pick Your '+qty+' Flavors';
  document.getElementById('bpickSub').textContent='Select at least '+qty+' bags — mix and match, duplicates allowed';
  renderBpickGrid();
  document.getElementById('bundlePickerOverlay').classList.add('show');
  document.body.style.overflow='hidden';
}
function closeBundlePicker(){
  document.getElementById('bundlePickerOverlay').classList.remove('show');
  document.body.style.overflow='';
}
function closeBundlePickerOutside(e){if(e.target===document.getElementById('bundlePickerOverlay'))closeBundlePicker();}
function renderBpickGrid(){
  const grid=document.getElementById('bpickGrid');
  grid.innerHTML=allFlavors.map((f,i)=>{
    const cnt=bpickSelected.filter(x=>x===i).length;
    return `
    <div class="bpick-item${cnt>0?' sel':''}" onclick="addBundleFlavor(${i})" data-idx="${i}">
      ${cnt>0?`<div class="bpick-cnt"><button class="bpick-minus" onclick="event.stopPropagation();removeBundleFlavor(${i})">−</button><span>${cnt}</span></div>`:''}
      <img src="${f.img}" alt="${f.name}" loading="lazy">
      <div class="bpick-item-name">${f.name}</div>
      <div class="bpick-item-price">$${f.price.toFixed(2)}</div>
      <div class="bpick-item-line">${f.line}</div>
    </div>`;
  }).join('');
  updateBpickState();
}
function addBundleFlavor(idx){
  bpickSelected.push(idx);
  renderBpickGrid();
}
function removeBundleFlavor(idx){
  const pos=bpickSelected.lastIndexOf(idx);
  if(pos>=0){bpickSelected.splice(pos,1);}
  renderBpickGrid();
}
function updateBpickState(){
  const total=bpickSelected.length;
  const done=total>=bpickQty;
  const counter=document.getElementById('bpickCounter');
  counter.textContent=total+' selected (min '+bpickQty+')';
  counter.classList.toggle('done',done);
  const rawPrice=bpickSelected.reduce((s,i)=>s+allFlavors[i].price,0);
  const tier=BUNDLE_TIERS.slice().reverse().find(t=>total>=t.qty);
  const pct=tier?tier.pct:0;
  const discountedPrice=Math.round(rawPrice*(1-pct/100)*100)/100;
  const savings=(rawPrice-discountedPrice).toFixed(2);
  document.getElementById('bpickTotal').innerHTML=done
    ?(pct>0
      ?`Bundle price: <strong>$${discountedPrice.toFixed(2)}</strong> <span style="color:var(--red);font-size:16px">Save $${savings} (${pct}% off)</span>`
      :`Bundle price: <strong>$${rawPrice.toFixed(2)}</strong>`)
    :`<span style="color:#aaa">Select ${bpickQty-total} more bag${bpickQty-total!==1?'s':''}</span>`;
  const btn=document.getElementById('bpickAtc');
  btn.disabled=!done;
  btn.textContent=done?'Add '+total+' Bags to Cart →':'Select All Flavors First';
  document.querySelectorAll('.bpick-item').forEach((el,i)=>{
    const cnt=bpickSelected.filter(x=>x===i).length;
    el.classList.toggle('sel',cnt>0);
    el.classList.toggle('maxed',false);
    const check=el.querySelector('.bpick-check');
    if(cnt>1){
      if(!check){const c=document.createElement('span');c.className='bpick-check';c.style.cssText='position:absolute;top:6px;left:8px;background:var(--red);color:#fff;font-size:16px;font-weight:900;border-radius:99px;padding:1px 6px';c.textContent='×'+cnt;el.appendChild(c);}
      else check.textContent='×'+cnt;
    } else if(check){check.remove();}
  });
  // tier bar
  const tierDefs=[{id:'bpickTier3',qty:3},{id:'bpickTier6',qty:6},{id:'bpickTier12',qty:12}];
  tierDefs.forEach((t,i,arr)=>{
    const el=document.getElementById(t.id);if(!el)return;
    const isCurrent=total>=t.qty&&(i===arr.length-1||total<arr[i+1].qty);
    const isUnlocked=!isCurrent&&i<arr.length-1&&total>=arr[i+1].qty;
    el.classList.toggle('current',isCurrent);
    el.classList.toggle('unlocked',isUnlocked);
  });
  const a1=document.getElementById('bpickArrow1');const a2=document.getElementById('bpickArrow2');
  if(a1)a1.classList.toggle('lit',total>=6);
  if(a2)a2.classList.toggle('lit',total>=12);
  // nudge banner
  const nudge=document.getElementById('bpickNudge');
  if(nudge){
    const allTiers=[{qty:3,pct:3},{qty:6,pct:6},{qty:12,pct:12}];
    const next=allTiers.find(t=>total<t.qty);
    if(total===0){nudge.classList.remove('show','maxed');}
    else if(next){
      const need=next.qty-total;
      nudge.innerHTML=`🔥 Add <strong>${need} more bag${need!==1?'s':''}</strong> and unlock <strong>${next.pct}% off</strong> your whole bundle!`;
      nudge.classList.add('show');nudge.classList.remove('maxed');
    } else {
      nudge.innerHTML='🏆 <strong>Best deal unlocked!</strong> You\'re getting 12% off every bag in this bundle!';
      nudge.classList.add('show','maxed');
    }
  }
}
function addBundleToCart(){
  if(bpickSelected.length<bpickQty)return;
  bpickSelected.forEach(i=>{
    const f=allFlavors[i];
    addCart(f.name,f.emoji,f.price,f.line.toLowerCase().includes('filet')?'filet':'classic');
  });
  closeBundlePicker();
  setTimeout(openCart,200);
}

function closeExit(e){if(e.target===document.getElementById('exitOverlay')) closeExitBtn();}
function closeExitBtn(){document.getElementById('exitOverlay').classList.remove('show');}
function submitExitEmail(e){
  e.preventDefault();
  const btn=e.target.querySelector('button');
  btn.textContent='✓ Code Sent!';
  btn.style.background='#22c55e';
  setTimeout(()=>closeExitBtn(),2000);
}

/* ── WHOLESALE FORM ── */
function submitWholesale(e){
  e.preventDefault();
  const btn=e.target.querySelector('.ws-btn');
  btn.textContent='✓ Request Sent!';
  btn.style.background='#22c55e';
  setTimeout(()=>{btn.textContent='Request Pricing →';btn.style.background='';},3500);
}

/* ── LEGAL PAGES ── */
const _legalIds=['privacy-page','terms-page'];
function _showLegalPage(id,hash){
  _legalIds.forEach(lid=>document.getElementById(lid).style.display='none');
  document.getElementById('pd-page').style.display='none';
  document.getElementById('checkout-page').style.display='none';
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#privacy-page):not(#terms-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='none');
  document.getElementById(id).style.display='block';
  window.scrollTo({top:0,behavior:'smooth'});
  history.pushState({legal:id},'',window.location.pathname+'#'+hash);
}
function showPrivacy(){_showLegalPage('privacy-page','privacy');}
function showTerms(){_showLegalPage('terms-page','terms');}
function closeLegalPage(){
  _legalIds.forEach(lid=>document.getElementById(lid).style.display='none');
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#privacy-page):not(#terms-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='');
  history.pushState({},'',window.location.pathname);
  window.scrollTo({top:0,behavior:'smooth'});
}
/* ── PRODUCT PAGES ── */
const pdProducts={
  'classic-original':{name:'Classic Original',emoji:'🥩',price:10.99,line:'classic',sub:'Hickory Smoke · Bold Beef Flavor',tag:'🧂 Savory',tagClass:'ft-savory',protein:'9G',sodium:'340MG',cals:'80',wt:'Net Wt. 2 oz (56g)',bg:'#FFADAD',stars:'4.9',revs:'3,841',nutri:'classic-original',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Classic-Original_r0.png?v=69951400074333031431777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-classic.png?v=150604522198402138311777263105'],desc:'Simply Beef Jerky Classic Original is premium whole muscle beef jerky made with natural hickory smoke, cracked black pepper, and clean simple seasonings. No artificial nitrates added, no MSG added. 9g protein per serving, USDA inspected. Bold beef flavor with nothing to hide.',premium:false},
  'black-pepper':{name:'Black Pepper & Sea Salt',emoji:'🧂',price:10.99,line:'classic',sub:'Bold & Clean',tag:'🧂 Savory',tagClass:'ft-savory',protein:'10G',sodium:'310MG',cals:'70',wt:'Net Wt. 2 oz (56g)',bg:'#A0C4FF',stars:'4.8',revs:'2,967',nutri:'black-pepper',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BPSS_r0.png?v=78338950319222752361777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-black-pepper.png?v=184455081321677056461777263105'],desc:'Bold cracked black pepper and flaky sea salt on premium whole muscle beef. The clean, straightforward beef jerky for people who want real flavor without the extras. No artificial nitrates added, no MSG added. 10g protein per serving, just 70 calories, USDA inspected.',premium:false},
  'bourbon-whiskey':{name:'Bourbon Whiskey',emoji:'🥃',price:10.99,line:'classic',sub:'Rich & Smoky',tag:'🔥 Smoky',tagClass:'ft-smoky',protein:'9G',sodium:'290MG',cals:'80',wt:'Net Wt. 2 oz (56g)',bg:'#FDFFB6',stars:'4.9',revs:'4,203',nutri:'bourbon',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_BourbonWhiskey_r0.png?v=26578859241790795801777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-bourbon.png?v=90937398760515010721777263105'],desc:'Simply Beef Jerky Bourbon Whiskey brings rich bourbon notes, natural hickory smoke, and a subtle caramel sweetness to premium whole muscle beef jerky. No artificial nitrates added, no MSG added, 9g protein per serving. A refined flavor made for those who appreciate the finer things.',premium:false},
  'garlic-brown-sugar':{name:'Garlic & Brown Sugar',emoji:'🧄',price:10.99,line:'classic',sub:'Sweet Meets Savory',tag:'🍯 Sweet',tagClass:'ft-sweet',protein:'9G',sodium:'320MG',cals:'90',wt:'Net Wt. 2 oz (56g)',bg:'#CAFFBF',stars:'4.8',revs:'2,714',nutri:'garlic-sugar',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_GarlicBrownSugar_r0.png?v=76699244042594610181777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-garlic.png?v=14421353201730429661777263105'],desc:'Roasted garlic and caramelized brown sugar come together in the most dangerously addictive sweet savory beef jerky you\'ll ever try. Simply Beef Jerky Garlic & Brown Sugar is made from whole muscle beef, no artificial nitrates added, no MSG added. 9g protein per serving, USDA inspected.',premium:false},
  'korean-bbq':{name:'Korean BBQ',emoji:'🔥',price:10.99,line:'classic',sub:'Bold & Adventurous',tag:'🌶 Spicy',tagClass:'ft-smoky',protein:'10G',sodium:'350MG',cals:'80',wt:'Net Wt. 2 oz (56g)',bg:'#FFAFCC',stars:'4.9',revs:'4,891',nutri:'korean-bbq',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Korean-Barbecue_r0.png?v=45774502629798211451777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-korean-bbq.png?v=116303586936642838721777263105'],desc:'Inspired by authentic Korean BBQ, this bold spicy beef jerky layers gochujang heat, toasted sesame, and savory soy on premium whole muscle beef. No artificial nitrates added. 10g protein per serving. The highest-rated flavor in our lineup for a reason.',premium:false,claims:['🚫 No Nitrates Added*','🚫 No Nitrites Added','🥩 Whole Muscle Beef','✅ USDA Inspected']},
  'teriyaki':{name:'Teriyaki',emoji:'🍯',price:10.99,line:'classic',sub:'Sweet & Savory',tag:'🍯 Sweet',tagClass:'ft-sweet',protein:'9G',sodium:'300MG',cals:'80',wt:'Net Wt. 2 oz (56g)',bg:'#FDFFB6',stars:'4.9',revs:'3,562',nutri:'teriyaki',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Regular-Teriyaki_r0.png?v=71833129174961791971777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-teriyaki.png?v=169960205994935736981777263105'],desc:'Simply Beef Jerky Teriyaki coats premium whole muscle beef in a perfectly balanced sweet teriyaki glaze. Mild, satisfying, and endlessly snackable. No artificial nitrates added, no MSG added, 9g protein per serving. The top teriyaki beef jerky for people who take their snacks seriously.',premium:false},
  'sweet-spicy':{name:'Sweet & Spicy',emoji:'🌶️',price:10.99,line:'classic',sub:'Heat Meets Sweet',tag:'🌶 Spicy',tagClass:'ft-smoky',protein:'9G',sodium:'330MG',cals:'80',wt:'Net Wt. 2 oz (56g)',bg:'#9BF6FF',stars:'4.9',revs:'4,127',nutri:'sweet-spicy',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_Sweet-Spicy_r0.png?v=120939306057222056991777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-sweet-spicy.png?v=57849305340742378271777263105'],desc:'Honey sweetness up front, then a slow building heat that keeps you reaching for more. Simply Beef Jerky Sweet &amp; Spicy is the ultimate sweet heat beef jerky. Made from whole muscle beef, no artificial nitrates added, no MSG added. 9g protein per serving, USDA inspected.',premium:false},
  'fm-original':{name:'Filet Mignon Original',emoji:'✨',price:13.99,line:'filet',sub:'Sweet & Smoky · Premium Cut',tag:'🧂 Savory',tagClass:'ft-savory',protein:'10G',sodium:'290MG',cals:'80',wt:'Net Wt. 2.25 oz (64g)',bg:'#BDB2FF',stars:'5.0',revs:'2,583',nutri:'fm-original',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_OG_r0.png?v=50821825560333601461777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-fm-original.png?v=94485970059942097771777263105'],desc:'The most premium beef jerky you can buy. Simply Beef Jerky Filet Mignon Original uses the same tender filet mignon cut served at fine steakhouses, seasoned with brown sugar, natural hickory smoke, black pepper and garlic. No artificial nitrates added, no MSG added. 10g protein per serving. Extraordinary jerky from an extraordinary cut.',premium:true},
  'fm-teriyaki':{name:'Filet Mignon Teriyaki',emoji:'✨',price:13.99,line:'filet',sub:'Sweet Teriyaki Glaze · Premium Cut',tag:'🍯 Sweet',tagClass:'ft-sweet',protein:'10G',sodium:'200MG',cals:'80',wt:'Net Wt. 2.25 oz (64g)',bg:'#FFD6E0',stars:'4.9',revs:'2,519',nutri:'fm-teriyaki',img:'//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105',images:['//simplybeefjerky.com/cdn/shop/t/161/assets/SimplyBeef_FM_Teriyaki_r0.png?v=109305576659410625131777263105','//simplybeefjerky.com/cdn/shop/t/161/assets/extra-fm-teriyaki.png?v=16548107666078035481777263105'],desc:'Simply Beef Jerky Filet Mignon Teriyaki wraps the most tender cut of beef in a rich, authentic teriyaki glaze for a premium jerky experience unlike anything else. The same filet mignon your favorite steakhouse uses, now in a bag you can take anywhere. No artificial nitrates added, no MSG added. 10g protein per serving.',premium:true}
};
let _pdCurrentSlug=null,_pdBasePrice=0;

function showProduct(slug){
  const p=pdProducts[slug];if(!p)return;
  _pdCurrentSlug=slug;_pdBasePrice=p.price;
  // populate
  pdInitGallery(p.images||[p.img],p.name);
  _pdImgWrapBg=`radial-gradient(circle at 50% 45%, rgba(255,255,255,0.9) 15%, ${p.bg} 85%)`;
  document.getElementById('pd-img-wrap').style.background=_pdImgWrapBg;
  document.getElementById('pd-bc-name').textContent=p.name;
  document.getElementById('pd-title').textContent=p.name;
  document.getElementById('pd-sub').textContent=p.sub;
  document.getElementById('pd-stars-n').textContent=p.stars;
  document.getElementById('pd-stars-c').textContent='('+p.revs+' reviews)';
  document.getElementById('pd-price-display').textContent='$'+p.price.toFixed(2);
  document.getElementById('pd-price-display').style.color='';
  document.getElementById('pd-wt').textContent=p.wt;
  document.getElementById('pd-sub-price').textContent='';
  document.getElementById('pd-sub-cb').checked=false;
  document.getElementById('pd-protein').textContent=p.protein;
  document.getElementById('pd-sodium').textContent=p.sodium;
  document.getElementById('pd-cals').textContent=p.cals;
  document.getElementById('pd-desc-title').textContent=p.name;
  document.getElementById('pd-desc-body').textContent=p.desc;
  document.getElementById('pd-nutri-btn').onclick=()=>openNutrition(p.name);
  // SEO: update title, meta description, og:image for this product
  document.title=p.name+' Beef Jerky | Simply Beef Jerky';
  document.querySelector('meta[name="description"]').setAttribute('content',p.desc+' No nitrates added, no MSG added. Ships USA-wide.');
  document.querySelector('meta[property="og:image"]').setAttribute('content','https://simplybeefjerky.com/'+p.img);
  document.querySelector('meta[name="twitter:image"]').setAttribute('content','https://simplybeefjerky.com/'+p.img);
  document.getElementById('pd-var-pills').innerHTML=Object.entries(pdProducts).map(([s,v])=>{
    const isActive=s===slug;
    const isFM=v.line==='filet';
    return `<button class="pd-var-btn${isFM?' filet-var':''}${isActive?' active':''}" onclick="showProduct('${s}')">${v.name}</button>`;
  }).join('');
  const btn=document.getElementById('pd-atcbtn');
  btn.className='pd-atcbtn'+(p.line==='filet'?' filet':'');
  // badges
  let badges=`<div class="fc-flavor-tag ${p.tagClass}">${p.tag}</div>`;
  if(p.premium)badges+=`<div class="fc-flavor-tag ft-premium">★ Signature</div>`;
  document.getElementById('pd-badges').innerHTML=badges;
  // custom claims per product
  const defaultClaims=['🚫 No Nitrates Added*','🚫 No MSG Added**','🥩 Whole Muscle Beef','✅ USDA Inspected'];
  const claimsList=p.claims||defaultClaims;
  document.querySelector('.pd-claims').innerHTML=claimsList.map(c=>`<span class="pd-claim">${c}</span>`).join('');
  // related (3 others)
  const others=Object.entries(pdProducts).filter(([s])=>s!==slug).slice(0,3);
  document.getElementById('pd-related-grid').innerHTML=others.map(([s,r])=>`
    <div class="pd-rel-card" onclick="showProduct('${s}')">
      <img class="pd-rel-img" src="${r.img}" alt="${r.name}" style="background:${r.bg}">
      <div class="pd-rel-body"><div class="pd-rel-name">${r.name}</div><div class="pd-rel-price">$${r.price.toFixed(2)}</div></div>
      <div class="pd-rel-foot"><button class="pd-rel-atc" onclick="event.stopPropagation();addCart('${r.name}','${r.emoji}',${r.price},'${r.line}');openCart()">+ Add to Cart</button></div>
    </div>`).join('');
  // show/hide
  document.getElementById('checkout-page').style.display='none';
  window.scrollTo({top:0,behavior:'instant'});
  document.getElementById('pd-page').style.display='block';
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='none');
  history.pushState({pd:slug},'',window.location.pathname+'#product-'+slug);
}

function closeProduct(scrollTarget){
  document.getElementById('pd-page').style.display='none';
  document.title='Simply Beef Jerky | Premium Beef Jerky | 9 Bold Flavors | No Nitrates Added | Hollywood, FL';
  document.querySelector('meta[name="description"]').setAttribute('content','Simply Beef Jerky — 100% beef, bold flavors, no nitrates added, no MSG added. 9 flavors including our premium Filet Mignon line. Shop online. Ships USA-wide from Hollywood, FL.');
  document.querySelector('meta[property="og:image"]').setAttribute('content','https://simplybeefjerky.com/logo.png');
  document.querySelector('meta[name="twitter:image"]').setAttribute('content','https://simplybeefjerky.com/logo.png');
  const mainSections=document.querySelectorAll('body > section, body > div:not(#checkout-page):not(#pd-page):not(#bundle-float):not(#bundle-left-tab):not(#bundlePickerOverlay):not(#exitOverlay):not(#nutritionModal):not(#cart-overlay):not(#cart):not(#ov):not(#search-overlay):not(.toast)');
  mainSections.forEach(el=>el.style.display='');
  history.pushState({},'',window.location.pathname);
  if(scrollTarget){
    const target=document.querySelector(scrollTarget);
    if(target)setTimeout(()=>target.scrollIntoView({behavior:'smooth'}),150);
  } else {
    window.scrollTo({top:0,behavior:'smooth'});
  }
}

document.addEventListener('click',function(e){
  const pdPage=document.getElementById('pd-page');
  if(!pdPage||pdPage.style.display==='none')return;
  const link=e.target.closest('a[href^="#"]');
  if(!link)return;
  const hash=link.getAttribute('href');
  if(!hash||hash==='#')return;
  e.preventDefault();
  closeProduct(hash);
});

function pdToggleSub(cb){
  const subPrice=Math.round(_pdBasePrice*0.90*100)/100;
  const priceEl=document.getElementById('pd-price-display');
  const subEl=document.getElementById('pd-sub-price');
  if(cb.checked){priceEl.textContent='$'+subPrice.toFixed(2);priceEl.style.color='#4CAF50';subEl.textContent='Subscribe price · Save 10%';}
  else{priceEl.textContent='$'+_pdBasePrice.toFixed(2);priceEl.style.color='';subEl.textContent='';}
}

function pdAddToCart(){
  const p=pdProducts[_pdCurrentSlug];if(!p)return;
  const cb=document.getElementById('pd-sub-cb');
  const isSub=cb&&cb.checked;
  const price=isSub?Math.round(p.price*0.90*100)/100:p.price;
  addCart(p.name,p.emoji,price,p.line);openCart();
}

window.addEventListener('popstate',function(e){
  if(e.state&&e.state.pd){showProduct(e.state.pd);}
  else if(e.state&&e.state.legal){_showLegalPage(e.state.legal,e.state.legal.replace('-page',''));}
  else{closeProduct();closeLegalPage&&closeLegalPage();}
});
(function(){
  const h=window.location.hash;
  if(h&&h.startsWith('#product-')){const slug=h.replace('#product-','');if(pdProducts[slug])showProduct(slug);}
  else if(h==='#privacy'){showPrivacy();}
  else if(h==='#terms'){showTerms();}
})();

/* ── PRODUCT IMAGE GALLERY ── */
let _pdGalleryImgs=[],_pdGalleryCur=0,_pdImgWrapBg='';
function pdInitGallery(imgs,alt){
  _pdGalleryImgs=imgs||[];_pdGalleryCur=0;
  const wrap=document.getElementById('pd-img-wrap');
  if(wrap)wrap.classList.remove('pd-photo-mode');
  const img=document.getElementById('pd-img');
  if(img){img.src=_pdGalleryImgs[0]||'';img.alt=alt||'';img.classList.remove('pd-img-fade');}
  // Preload all images so Next/Prev are instant
  _pdGalleryImgs.forEach(function(src){const p=new Image();p.src=src;});
  const nav=document.getElementById('pd-gallery-nav');
  const counter=document.getElementById('pd-gallery-counter');
  if(_pdGalleryImgs.length>1){
    if(nav)nav.style.display='flex';
    if(counter)counter.textContent='1 / '+_pdGalleryImgs.length;
  } else {
    if(nav)nav.style.display='none';
  }
}
function pdGalleryNav(dir){
  _pdGalleryCur=(_pdGalleryCur+dir+_pdGalleryImgs.length)%_pdGalleryImgs.length;
  pdGalleryShow();
}
function pdGalleryTo(idx){_pdGalleryCur=idx;pdGalleryShow();}
function pdGalleryShow(){
  const img=document.getElementById('pd-img');
  const wrap=document.getElementById('pd-img-wrap');
  if(!img)return;
  const isPhoto=_pdGalleryCur>0;
  img.classList.remove('pd-img-fade');
  img.src=_pdGalleryImgs[_pdGalleryCur]||'';
  if(wrap){wrap.style.background=isPhoto?'#0d0d0d':_pdImgWrapBg;wrap.classList.toggle('pd-photo-mode',isPhoto);}
  const counter=document.getElementById('pd-gallery-counter');
  if(counter)counter.textContent=(_pdGalleryCur+1)+' / '+_pdGalleryImgs.length;
}
